export enum MODULE_KIND {
  UNSET = 'Unset',
  FIRST_LEG_SHIPPING = 'FirstLegShipping',
  LAST_LEG_SHIPPING = 'LastLegShipping',
  MIDDLE_LEG_SHIPPING = 'MiddleLegShipping',
}
